export const getDocumentTitle = (title, includeTimestamp = true) => {
  return `${title ?? document.title}_${includeTimestamp ? new Date().getTime() : ''}`;
};
